<template>
  <v-dialog v-model="dialog" persistent width="1300">
    <v-card>
      <!-- Cabecera del formulario -->
      <v-card-title class="headline">
        <v-flex xs9> <v-icon>picture_as_pdf</v-icon> REPORTE</v-flex>
        <v-spacer></v-spacer>
        <v-btn flat icon title="Ver en otra ventana" @click="openNewWindow()">
          <v-icon>fullscreen</v-icon>
        </v-btn>
        <v-btn icon @click.native="close()">
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-layout>
          <v-flex>
            <embed
              :src="obtenerUrl()"
              type="application/pdf"
              width="100%"
              height="700px"
            />
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  // Variables iniciales
  data() {
    return {
      form: {},
      dialog: false,
      loading: false,
      url: "",
      api_backend: ""
    };
  },
  mounted() {
    this.$bus.$on("openDialogVerReporte", item => {
      //this.tipo_documento = this.obtenerTipo(item)
      this.form = item;
      this.url = this.obtenerUrl();
      this.api_backend = process.env.API_URL.split("api/");
      this.dialog = true;
    });
  },
  methods: {
    obtenerUrl() {
      try {
   
        let url;
        let user = this.$storage.get("user");
        let nombre_reporte = "";
        let formato_doc = "output=pdf";
        let nombre_carpeta;
           nombre_carpeta="vacaciones"
        
        let url_carpeta = process.env.REPORTE_URL_OFICIAL.replace(
          /{carpeta}/g,
          nombre_carpeta
        );
         if (this.form.reprogramacion == 1) {//reporte antiguo vacacion por funcionario
          nombre_reporte = "rpt_vacacion";
        }
         if (this.form.reprogramacion == 2) {//reporte nuevo vacacion por funcionario
          if (this.form.id_estado_programacion==72) {
            nombre_reporte = "rpt_cronograma_vacacion_historico";
          }else{
            nombre_reporte = "rpt_cronograma_vacacion_persona";
          }
          
        }
         if (this.form.reprogramacion == 6) {
          
          nombre_reporte = "rpt_cronograma_vacacion";
        }
        if (this.form.reprogramacion == 10) {
          
          nombre_reporte = "rpt_cronograma";
        }

        if (this.form.reprogramacion == 15) {
          
          nombre_reporte = "rpt_cronograma_saldos";
            console.log("nombre_reporte",nombre_reporte);
        }
        
        url = `${url_carpeta}${nombre_reporte}&${formato_doc}`;
         let url_parametros
        //Parametros
        let id_programacion = this.form.id;
        // URL con parametros
        if (this.form.reprogramacion == 1) {//reporte antiguo vacacion por funcionario
          url_parametros = `${url}&id_persona=${this.form.id_persona}&usuario=${user.usuario}`;
        }
        if (this.form.reprogramacion == 2) {//reporte nuevo vacacion por funcionario
          if (this.form.id_estado_programacion==72) {
            url_parametros = `${url}&P_ID_PERSONA=${this.form.id_persona}&P_PERIODO=${this.form.periodo}&P_ID_UNIDAD=`;
          }else{
            url_parametros = `${url}&id_persona=${this.form.id_persona}&gestion=${this.form.periodo}`;
          }
        }
        if (this.form.reprogramacion == 3) {
          url_parametros = `${url}&id_persona=${this.form.id_persona}&usuario=${user.usuario}`;
        }
        if (this.form.reprogramacion == 6) {//---------------------Reporte grande filtrar----------------
          url_parametros = `${url}&p_fecha_ini=${this.form.fecha_inicio}&p_fecha_fin=${this.form.fecha_fin}&p_unidad_general=${this.form.id_unidad_general}&p_paterno=${this.form.paterno}&p_materno=${this.form.materno}&p_nombres=${this.form.nombres}&p_ci=${this.form.ci}&p_item=${this.form.item}&p_unidad_especifica=${this.form.id_unidad_especifica}`;
        }
        if (this.form.reprogramacion == 10) {//---------------------Reporte grande filtrar----------------
          url_parametros = `${url}&id_unidad=${this.form.id_unidad}&id_persona=${this.form.id_persona}`;
        }
          if (this.form.reprogramacion == 15) {//---------------------Reporte grande filtrar----------------
          url_parametros = `${url}`;
        }
        console.log(url_parametros)
        return url_parametros;
      } catch (error) {
        console.log(error);
      }
    },
    close() {
      this.loading = false;
      this.dialog = false;
      this.url = "";
      this.$bus.$emit("closeDialogVerReporteCronograma");
    },
    openNewWindow() {
      window.open(this.url);
    }
  }
};
</script>
<style></style>



// WEBPACK FOOTER //
// src/components/admin/vacaciones/dialogs/VerReporte.vue